import { combineReducers } from "redux"
import i18n from "./i18n/"

const rootReducer = combineReducers({
    i18n: i18n,
})

export default rootReducer
